import { cssThemedValue } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

type Props = {
  children?: React.ReactNode;
  label: React.ReactNode;
  tooltip?: React.ReactNode;
};

const Root = styled.div`
  display: flex;
  flex-flow: column;
  padding: 24px 0;
  border-block-end: 1px solid ${cssThemedValue('borderPrimary')};
`;

const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-block-end: 10px;
`;

const Label = styled(T.Small)`
  display: flex;
  text-transform: capitalize;
  color: ${cssThemedValue('textSecondary')};
`;

const Content = styled(T.Body3)`
  color: ${cssThemedValue('textPrimary')};
  letter-spacing: -0.154px;
`;

const FormItem = ({ children, label, tooltip }: Props) => {
  return (
    <Root>
      <TopRow>
        <Label>
          {label}
          {tooltip}
        </Label>
      </TopRow>
      <Content>{children}</Content>
    </Root>
  );
};

export default FormItem;
